
import React, {
  FC, useState, useEffect,
} from 'react';
import { useForm, useFieldArray } from 'react-hook-form';

type Charactor = {
  checklist_id: number;
  item_name: string;
};

const data: Charactor[] = [
  {
    checklist_id: 1, item_name: '黒崎',
  },
  {
    checklist_id: 2, item_name: '井上',
  },
  {
    checklist_id: 3, item_name: '井上',
  },
];


export const ArrayForm: FC = () => {
  const [charactor, setCharactor] = useState<Charactor[]>([]);
  const {
    handleSubmit, control, register, reset,
  } = useForm({});

  const { fields, append, remove } = useFieldArray({
    control,
    name: 'bleach',
  });

  useEffect(() => {
    reset({
      bleach: data,
    });
  }, [reset]);


  const onSubmit = (submitData: { bleach: Charactor[] }) => {
    console.log(submitData);
    console.log('is not Empty');
    setCharactor(submitData.bleach);
  };



  return (
    <section>
      <h1>react-hook-form useFieldArray</h1>
      <form onSubmit={handleSubmit(onSubmit)}>
        <table>
          <tbody>
            {fields.map((field, index) => (
              <tr>
                <td>
                  <input
                    type="text"
                    {...register(`bleach[${index}].checklist_id`, { required: true })}
                  />
                </td>
                <td>
                  <input
                    type="text"
                    {...register(`bleach[${index}].item_name`, { required: true })}
                  />
                </td>

                <td>
                  <button type="button" onClick={() => remove(index)}>削除</button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>

        <section>
          <button
            type="button"
            onClick={() => append({})}
          >行を追加する
          </button>
        </section>
        <input type="submit" />
      </form>

      <h3>送信データ</h3>
      {charactor.map((c) => (
        <p>
          {`${c.checklist_id + c.item_name} `}
        </p>
      ))}
    </section>
  );
};

export default ArrayForm;

/*項目追加削除*/
/*
import React, {
  FC, useState, useEffect,
} from 'react';
import { useForm } from "react-hook-form";


type Charactor = {
  firstName: string;
  lastName: string;
};
 
const data: Charactor[] = [
  {
    firstName: '一護', lastName: '黒崎',
  },
  {
    firstName: '織姫', lastName: '井上',
  },
  {
    firstName: '織姫', lastName: '井上',
  },
];


function ArraySample() {
  const [charactor, setCharactor] = useState<Charactor[]>([]);
  const [indexes, setIndexes] = React.useState([]);
  const [counter, setCounter] = React.useState(0);
  const { register, handleSubmit } = useForm();



  const onSubmit = data => {
    console.log(data);
  };

  const addFriend = () => {
    setIndexes(prevIndexes => [...prevIndexes, counter]);
    setCounter(prevCounter => prevCounter + 1);
  };

  const removeFriend = index => () => {
    setIndexes(prevIndexes => [...prevIndexes.filter(item => item !== index)]);
    setCounter(prevCounter => prevCounter - 1);
  };

  const clearFriends = () => {
    setIndexes([]);
  };

  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      {indexes.map(index => {
        const fieldName = `friends[${index}]`;
        return (
          <fieldset name={fieldName} key={fieldName}>
            <label>
              First Name {index}:
              <input
                type="text"
                {...register(`${fieldName}.firstName`)}
              />
            </label>

            <label>
              Last Name {index}:
              <input
                type="text"
                {...register(`${fieldName}.lastName`)}
              />
            </label>
            <button type="button" onClick={removeFriend(index)}>
              Remove
            </button>
          </fieldset>
        );
      })}

      <button type="button" onClick={addFriend}>
        Add Friend
      </button>
      <button type="button" onClick={clearFriends}>
        Clear Friends
      </button>
      <input type="submit" />
    </form>
  )
}

export default ArraySample;
*/

/* ボタン送信キャッチ、イベント
import * as React from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import Slide from '@mui/material/Slide';
import { TransitionProps } from '@mui/material/transitions';

const Transition = React.forwardRef(function Transition(
  props: TransitionProps & {
    children: React.ReactElement<any, any>;
  },
  ref: React.Ref<unknown>,
) {
  return <Slide direction="up" ref={ref} {...props} />;
});

function App() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("")

  /**
   * メールアドレス値変更処理
   * @param {*} e 
   */
/*
const changeEmail = (e) => {
  setEmail(e.target.value);
}

/**
 * パスワードの値変更処理
 * @param {*} e 
 */

/*
const changePassword = (e) => {
  setPassword(e.target.value);
}

/**
 * 送信ボタンクリック
 * @param {*} e 
 */
/*
const clickSubmit = (e) => {
  console.log("送信されました");
  console.log({password});
  // POST処理
}






 


return (
  <div className="App">
    <div>
      <input type="email" id="email" onChange={changeEmail} value={email}></input>
      <input type="password" id="password" onChange={changePassword} value={password}></input>
      <button type="submit" onClick={clickSubmit}>送信</button>
    </div>
  </div>
);
}

export default App;
*/




{/* <Box component="div"
                sx={{
                  width: '650px',
                  height: '400px',
                  mx: 'auto',
                  mt: '8px',
                  bgcolor: '#ABABAB',
                  border: '1px solid blue'
                }}>
                <Box component="div"
                  sx={{
                    width: '95%',
                    height: '90%',
                    mx: 'auto',
                    mt: '8px',
                    pb: '8px',
                    bgcolor: '#006565',
                    border: '2px solid white',
                    color: 'white'
                  }}>
                  <Box component="div"
                    sx={{
                      width: '95%',
                      height: '95%',
                      my: '4px',
                      mx: 'auto',
                      bgcolor: '#006565',
                      // border: '1px solid white',
                      color: 'white',

                    }}>

                    <Box style={{
                      height: 'calc(100% / 6)',
                      width: 'calc(100% / 5)',
                      border: '1px solid #fff',
                      textAlign: 'center',
                      borderRight: '1px solid white',
                      // lineHeight: '100%',
                    }}>
                      <p style={{}}>工事名</p>
                    </Box>


                    <Box
                      sx={{
                        height: 'calc(100% / 6)',
                        width: '100%',
                        border: '1px solid white',
                      }}
                    >
                      <span style={{
                        display: 'flex',
                        flexDirection: 'column',
                        justifyContent: 'center',
                        alignItems: 'center',
                        width: '20%',
                        height: '100%',
                        borderRight: '1px solid white',
                        textAlign: 'center',

                      }}>工種</span>
                    </Box>


                    <Box
                      sx={{
                        height: 'calc(100% / 6)',
                        width: '100%',
                        border: '1px solid white',
                      }}
                    >
                      <span style={{
                        display: 'flex',
                        flexDirection: 'column',
                        justifyContent: 'center',
                        alignItems: 'center',
                        width: '20%',
                        height: '100%',
                        borderRight: '1px solid white',
                        textAlign: 'center',

                      }}>種別</span>
                    </Box>


                    <Box
                      sx={{
                        height: 'calc(100% / 6)',
                        width: '100%',
                        border: '1px solid white',
                      }}
                    >
                      <span style={{
                        display: 'flex',
                        flexDirection: 'column',
                        justifyContent: 'center',
                        alignItems: 'center',
                        width: '30%',
                        height: '100%',
                        borderRight: '1px solid white',
                        textAlign: 'center',

                      }}>土木共通仕様書番号</span>
                    </Box>


                    <Box
                      sx={{
                        height: 'calc(100% / 6)',
                        width: '100%',
                        border: '1px solid white',
                      }}
                    >
                      <span style={{
                        display: 'flex',
                        flexDirection: 'column',
                        justifyContent: 'center',
                        alignItems: 'center',
                        width: '30%',
                        height: '100%',
                        borderRight: '1px solid white',
                        textAlign: 'center',

                      }}>実施日</span>
                    </Box>

                    <Box
                      sx={{
                        height: 'calc(100% / 6)',
                        width: '100%',
                        border: '1px solid white',
                      }}
                    >
                      <span style={{
                        display: 'flex',
                        flexDirection: 'column',
                        justifyContent: 'center',
                        alignItems: 'center',
                        width: '30%',
                        height: '100%',
                        borderRight: '1px solid white',
                        textAlign: 'center',

                      }}>実施会社</span>
                    </Box>


                  </Box>
                </Box>
              </Box> */}